module.exports = "<div class=\"container-fluid\" ui-view></div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/periodic_tasks/periodic_tasks.html
// module id = 713
// module chunks = 0